import { apiClient } from '../apiClients';
import { Endpoints } from '../../network';
import { contactQueryPayload } from '../../utils/interfaces/contactUs';

export enum ISendFeedbackType {
  FEATURE_REQUEST = 'FEATURE_REQUEST',
  REPORT_BUG = 'REPORT_BUG',
  FEEDBACK = 'FEEDBACK',
}

interface ISendFeedback {
  message: string;
  type: ISendFeedbackType;
}

export const contactQuery = async (data: contactQueryPayload) => {
  const response = await apiClient.post(`${Endpoints.contactUs}`, data);

  return response?.data;
};

export const sendFeedback = async (data: ISendFeedback) => {
  const response = await apiClient.post(`${Endpoints.contactUs}`, data);

  return response?.data;
};
